import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/data.service";
import { Input } from "@angular/core";

interface MetaButton {
  dropped: boolean;
}
@Component({
  selector: "app-button-layout",
  templateUrl: "./button-layout.component.html",
  styleUrls: ["./button-layout.component.scss"],
})
export class ButtonLayoutComponent implements OnInit {

  @Input() buttonData: any;

  metalayoutbutton: any[] = [];
  droppedButtons: any[] = [];

  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;
  profileId = "";
  metaobjectId = " ";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  viewName = "";
  publicAccess = false;
  mode = "New";
  guid: any;
  metalayout:any;
  //metaProfileLayoutId = "";
  metaLayoutGroupId = "";
  metaProfileLayoutWebId = "";

  metaLayoutGroupIdSection = "";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.metaLayoutGroupId = this.route.snapshot.params.metagroupid;
    });

    if (this.buttonData) {
      console.log("inputButton", this.buttonData);
    }
    this.droppedButtons = this.buttonData.map((button) => ({
      ...button,
      dropped: false,
    }));

    // this.retrieveMetabuttons();
  }
  onDragStart(event: DragEvent, button: MetaButton) {
    console.log("metabutton data:", button);

    if (button.dropped) {
      event.preventDefault();
      return;
    }

    // metabutton.dropped = true;
    event.dataTransfer.setData("application/json", JSON.stringify(button));
  }

  retrieveMetabuttons() {
    return new Promise((resolve, reject) => {
      console.log("getMetabuttons");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metabutton: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaButtonsLayout(postOption).subscribe(
        (res) => {
          console.log("res", res);
          const metabuttons = res.data.metabuttons;

          if (metabuttons) {
            this.metalayoutbutton = metabuttons.map((button: MetaButton) => {
              button.dropped = false;
              return button;
            });
          }
          if (metabuttons) {
            this.metalayoutbutton = metabuttons; // Store the fetched metabuttons in metalayoutbutton array
          }
          if (res !== null && res.success == 1) {
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metabuttons data!");
            this.errorMessage =
              res != null ? res.message : "No metabuttons data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
